import { defineStore } from 'pinia';

const defaultDateTimeConfig = {
  full: 'DD/MM/YYYY HH:mm:ss',
  date: 'DD/MM/YYYY',
  time: 'HH:mm:ss',
  dayMonthNumeric: 'DD/MM',
  dayMonthShort: 'DD MMM',
  dayMonthLong: 'DD MMMM',
  monthYearNumeric: 'MM/YYYY',
  monthYearShort: 'MMM YYYY',
  monthYearLong: 'MMMM YYYY',
  hourMinute: 'HH:mm',
  year: 'YYYY',
  month: 'MM',
  day: 'DD',
  hour: 'HH',
  minute: 'mm',
  second: 'ss',
  ampm: '',
  monthShort: 'MMM',
  monthLong: 'MMMM',
  dateSeparator: '/',
  timeSeparator: ':',
  is12h: false,
  timezone: 'Asia/Singapore',
};

export const useAppStore = defineStore('appStore', {
  state: () => ({
    loadingCount: 0,
    dateTimeConfig: { ...defaultDateTimeConfig },
  }),
  getters: {
    isLoading: (state) => state.loadingCount > 0,
    getDateTimeConfig: (state) => state.dateTimeConfig || defaultDateTimeConfig,
  },
  actions: {
    increaseLoadingCount() {
      this.loadingCount += 1;
    },
    decreaseLoadingCount() {
      if (this.loadingCount > 0) {
        this.loadingCount -= 1;
      }
    },
    setDateTimeConfig(config) {
      this.dateTimeConfig = { ...defaultDateTimeConfig, ...config };
    },
  },
});
